document.addEventListener("DOMContentLoaded", function () {
    const siteHeader = document.getElementById('SiteHeader');
    const sectionHero = document.getElementById('sectionHero');
    if (siteHeader && sectionHero) {
        const headerHeight = siteHeader.offsetHeight;
        sectionHero.style.paddingTop = `${headerHeight}px`;
    }

    const productVideoOverlay = document.getElementById('productVideoOverlay');
    const productVideoModal = document.getElementById('productVideoModal');
    const productHTMVideoModal = document.getElementById('productHTMVideoModal');

    // Add null checks for video modal elements
    if (productVideoOverlay) {
        productVideoOverlay.onclick = () => {
            productVideoModal?.classList.remove("show");
            productHTMVideoModal?.classList.remove("show");
            productVideoOverlay.classList.remove("open");
        }
    }

    // Wait for the chart app's actual DOM changes, rather than polling every second.
    function waitForSizeChart() {
        let chartObserver, containerObserver, deadline;
        const stop = () => {
            chartObserver?.disconnect();
            containerObserver?.disconnect();
            clearTimeout(deadline);
        };
        function augment(target) {
            const existingBtn = target.querySelector('.scr-open-size-chart');
            const hasNewBtn = target.querySelector('.btn-video');

            if (existingBtn && document.body.classList.contains('template-apparel')) {
                existingBtn.textContent = 'Size Chart';
            }

            // Proceed only if existing button is already there and new one isn't
            if (existingBtn && !hasNewBtn) {
                const newButton = document.createElement('button');
                newButton.className = 'btn-video btn-video-popup';
                newButton.type = 'button';
                if (document.body.classList.contains('template-apparel')) {
                    newButton.textContent = 'Model Video';
                } else {
                    newButton.textContent = 'Look Inside';
                }

                const htmButton = document.createElement('button');
                htmButton.className = 'btn-video btn-htm-popup';
                htmButton.type = 'button';
                htmButton.textContent = "How It's Made";

                // Create FAQ link
                const faqSection = document.querySelector('[id^="shopify-section"][id*="faq"]');
                const newFAQ = document.createElement('a');
                newFAQ.className = 'btn-faq';
                newFAQ.textContent = 'FAQ';
                if (faqSection) {
                    newFAQ.href = `#${faqSection.id}`;
                }

                newButton.addEventListener('click', () => {
                    const videoModal = document.getElementById('productVideoModal');
                    const videoOverlay = document.getElementById('productVideoOverlay');
                    if (videoModal && videoOverlay) {
                        videoModal.classList.add('show');
                        videoOverlay.classList.add('open');
                    }
                });

                htmButton.addEventListener('click', () => {
                    const videoModal = document.getElementById('productHTMVideoModal');
                    const videoOverlay = document.getElementById('productVideoOverlay');
                    if (videoModal && videoOverlay) {
                        videoModal.classList.add('show');
                        videoOverlay.classList.add('open');
                    }
                });

                // Append without removing anything
                target.appendChild(newButton);
                target.appendChild(htmButton);
                // target.appendChild(newFAQ);

                // Finish once the legacy controls are available
                return true;
            }

            return Boolean(existingBtn && hasNewBtn);
        }
        function watch(target) {
            containerObserver?.disconnect();
            if (augment(target)) { stop(); return; }
            chartObserver = new MutationObserver(() => {
                if (augment(target)) stop();
            });
            chartObserver.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        }
        deadline = setTimeout(stop, 30000);
        const target = document.querySelector('.best-fit-size-chart');
        if (target) { watch(target); return; }
        // Preserve late-injected app containers on older templates, within the original deadline.
        containerObserver = new MutationObserver(records => {
            for (const record of records) {
                if (record.type === 'attributes' && record.target.matches('.best-fit-size-chart')) {
                    watch(record.target); return;
                }
                for (const node of record.addedNodes) {
                    if (node.nodeType !== 1) continue;
                    const target = node.matches('.best-fit-size-chart') ? node : node.querySelector('.best-fit-size-chart');
                    if (target) { watch(target); return; }
                }
            }
        });
        containerObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    waitForSizeChart();

    // Sticky functionality shared across promotion and sticky ATC sections
    function initStickySection(sectionSelector) {
        const section = document.querySelector(sectionSelector);
        const footer = document.querySelector('[id*="text_with_icons"]');

        if (!section) {
            return;
        }

        let isSticky = false;
        let originalPosition = section.offsetTop;
        const stickyClass = 'show';

        function handleScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const sectionHeight = section.offsetHeight;
            let footerTop = null;
            if (footer) {
                const footerRect = footer.getBoundingClientRect();
                footerTop = footerRect.top + window.pageYOffset;
            }

            if (
                scrollTop > originalPosition &&
                (!footerTop || scrollTop + sectionHeight < footerTop)
            ) {
                if (!isSticky) {
                    section.classList.add(stickyClass);
                    isSticky = true;
                }
            } else if (isSticky) {
                section.classList.remove(stickyClass);
                isSticky = false;
            }
        }

        function handleResize() {
            originalPosition = section.offsetTop;
            handleScroll();
        }

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        handleScroll();
    }

    // Initialize sticky behavior for promotion and sticky ATC sections when DOM is ready
    initStickySection('[id*="shopdev_promotion"]');
    initStickySection('.section-sticky-atc');

    const btnHowItsMade = document.querySelector('.btn-video-popup:not(.btn-video)');
    if (btnHowItsMade) {
        btnHowItsMade.addEventListener('click', function(e) {
            e.preventDefault();

            const htmModal = document.getElementById('productHTMVideoModal');
            const videoOverlay = document.getElementById('productVideoOverlay');

            if (htmModal && videoOverlay) {
                htmModal.classList.add('show');
                videoOverlay.classList.add('open');
            }
        });
    }
});
